import { PUBLIC_ASSETS_BASE_URL } from '@app/app-constants'

export function capitalizeFirstLetter(string: string) {
  return string.trim().charAt(0).toUpperCase() + string.trim().slice(1).toLowerCase()
}

export function generateS3Url(src: string, { preserveCase = false } = {}) {
  const normalized = preserveCase ? src : src.toLocaleLowerCase()

  if (normalized.toLowerCase().startsWith('s3://')) {
    const iconIdS3 = normalized.replace(/^s3:\/\//i, '').replace('.svg', '')
    return `${PUBLIC_ASSETS_BASE_URL}/icons/${iconIdS3}.svg`
  }

  return src
}

export const englishList = (items: string[]): string => {
  if (items.length == 0) return ''
  if (items.length == 1) return items[0]

  // Replace for example: "Property boundaries, Marae, and Industrial properties and facilities"
  // with: "Property boundaries, Marae, and Industrial properties & facilities"
  const ampersandedItems = items.map((item) => item.replace(' and ', ' & '))

  const lastItem = ampersandedItems.pop()
  if (ampersandedItems.length == 1) return `${ampersandedItems[0]} and ${lastItem}`

  return `${ampersandedItems.join(', ')}, and ${lastItem}`
}

export function truncateToNearestSpace(text: string, maxLength: number): string {
  if (text.length > maxLength) {
    const truncatedText = text.substring(0, maxLength)
    const lastSpacePos = truncatedText.lastIndexOf(' ')
    if (lastSpacePos > 0) return truncatedText.substring(0, lastSpacePos) + '...'
    return truncatedText + '...'
  }
  return text
}

export function snakeToPascalCase(input: string): string {
  const words = input.split('_')
  const pascalWords = words.map(
    (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
  )
  return pascalWords.join('')
}

export function toSnakeCase(input: string): string {
  const words = input.split(' ')

  if (words.length === 0) {
    return ''
  }

  const snakeCaseWords = words.map((word) => word.toLowerCase())

  return snakeCaseWords.join('_')
}

export function firstLetterToUpperCase(input: string): string {
  if (input.length === 0) {
    return ''
  }
  return input.charAt(0).toUpperCase() + input.slice(1)
}

export function snakeCaseToTitleCase(input: string): string {
  const words = input.split('_') // Split the input string by underscores
  const capitalizedWords = words.map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
  return capitalizedWords.join(' ') // Join the words with spaces
}

export function slugify(input: string): string {
  return input
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '') // Remove special characters except spaces and hyphens
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/-+/g, '-') // Replace multiple hyphens with single hyphen
    .replace(/^-+|-+$/g, '') // Remove leading/trailing hyphens
}
